module.exports = __webpack_public_path__ + "img/dog-purchase.b9b34796.png";